import { HeaderStore } from './types';
import { HeaderActions } from './actions';

export const defaultState: HeaderStore = {
  error: null,
  isLoading: false,
  isLoaded: false,
  designers: [],
  productCategories: [],
  articleCategories: [],
  aboutPage: null,
  professionalsPage: null,
  articles: [],
  products: [],
  designerCards: [],
  heroBox: null,
  europe_url: null,
  australia_url: null,
  usa_url: null,
};

const reducer = (
  state: HeaderStore = defaultState,
  action: { type: HeaderActions; payload?: any }
): HeaderStore => {
  switch (action.type) {
    case HeaderActions.FetchDataBegin: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        designers: [],
        error: null,
      };
    }
    case HeaderActions.FetchDataError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case HeaderActions.FetchDataSuccess: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: null,
        designers: [...action.payload.designers],
        designerCards: [...action.payload.designerCards],
        productCategories: [...action.payload.productCategories],
        articleCategories: [...action.payload.articleCategories],
        aboutPage: action.payload.aboutPage.length ? action.payload.aboutPage[0] : null,
        professionalsPage: action.payload.professionalsPage.length
          ? action.payload.professionalsPage[0]
          : null,
        articles: [...action.payload.articles],
        products: [...action.payload.products],
        europe_url: action.payload.europe_url,
        australia_url: action.payload.australia_url,
        usa_url: action.payload.usa_url,
      };
    }

    case HeaderActions.UpdateHeroBox: {
      return {
        ...state,
        heroBox: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default reducer;
